import type { RightPanelView } from '../hooks/useRightPanelState'

export function getRightPanelRenderState({
  rightPanelView,
  hasTimelineContent,
  hasTripListContent,
  isItineraryLoading,
}: {
  rightPanelView: RightPanelView
  hasTimelineContent: boolean
  hasTripListContent: boolean
  isItineraryLoading: boolean
}) {
  const isTimelineView = rightPanelView === 'timeline'
  const isListView = rightPanelView === 'list'

  return {
    shouldShowMap: rightPanelView === 'map',
    // While the first itinerary fetch is in flight there is nothing to be empty about yet,
    // so the empty state must not flash before restored content arrives.
    shouldShowTimelineLoadingState: isTimelineView && !hasTimelineContent && isItineraryLoading,
    shouldShowTimelineEmptyState: isTimelineView && !hasTimelineContent && !isItineraryLoading,
    shouldShowTripPlanCanvas: isTimelineView && hasTimelineContent,
    shouldShowListLoadingState: isListView && !hasTripListContent && isItineraryLoading,
    shouldShowListEmptyState: isListView && !hasTripListContent && !isItineraryLoading,
    shouldShowListView: isListView && hasTripListContent,
  }
}
